(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edm-catalogue-navigation"] && !Shopify.designMode) return;
  try {
    
  function activateHashLink(a) {
    document.querySelectorAll('.catalogue-nav-link').forEach(function (link) {
      link.classList.remove('active');
    });
    a.classList.add('active');
  }
  window.addEventListener('hashchange', function (event) {
    activateHashLink(document.querySelector(`a[href="${location.hash}"]`));
  });
  document.querySelectorAll('.catalogue-nav-link').forEach(function (link) {
    const observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          // window.location.hash = link.hash;
          activateHashLink(link);
        }
      },
      { rootMargin: '-50% 0px' }
    );
    observer.observe(document.querySelector(link.hash));
  });

  (function () {
    const header = document.querySelector('.edm-catalogue-header');
    if (!header) return;

    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const threshold = 8;
    let lastScrollY = window.scrollY;
    let anchorTop = 0;
    let ticking = false;

    function stickyTop() {
      const top = parseFloat(getComputedStyle(header).top);
      return Number.isFinite(top) ? top : 0;
    }

    function measureAnchor() {
      const hidden = header.classList.contains('is-hidden');
      if (hidden) header.classList.remove('is-hidden');
      anchorTop = header.getBoundingClientRect().top + window.scrollY;
      if (hidden) header.classList.add('is-hidden');
    }

    function update() {
      const scrollY = Math.max(window.scrollY, 0);
      const delta = scrollY - lastScrollY;
      ticking = false;

      if (!mobileQuery.matches) {
        header.classList.remove('is-hidden');
        lastScrollY = scrollY;
        return;
      }

      const pinned = scrollY + stickyTop() >= anchorTop - 1;

      if (!pinned || scrollY <= threshold) {
        header.classList.remove('is-hidden');
      } else if (delta > threshold) {
        header.classList.add('is-hidden');
      } else if (delta < -threshold) {
        header.classList.remove('is-hidden');
      }

      lastScrollY = scrollY;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    measureAnchor();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      measureAnchor();
      update();
    });
    mobileQuery.addEventListener('change', function () {
      measureAnchor();
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edm-form-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const url = new URL(window.location.href);
    if (window.location.hash === '#contact_form' && url.searchParams.get('contact_posted') === 'true') {
      const modal = document.getElementById('edm-modal-alert');
      modal.querySelector('.modal-content-body-title').innerHTML = 'Thanks for your message';
      modal.querySelector('.modal-content-body').innerHTML = '<p>We will get back to you as soon as possible</p>';
      modal.showModal();
      modal.addEventListener('toggle', () => {
        if (!modal.open) {
          history.replaceState(null, null, window.location.pathname);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edm-modal-stockist"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const url = new URL(window.location.href);
    if (url.searchParams.get('form_type') === 'contact') {
      document.getElementById('edm-modal-stockist').showModal();
    }
    const successPopup = document.getElementById('edm-modal-stockist-submitted');
    if (url.searchParams.get('contact_posted') === 'true' && location.hash === '#stockist-form') {
      successPopup.showModal();
      location.hash = '';
    }

    const formDataFromQuery = Object.fromEntries(url.searchParams);
    const form = document.getElementById('stockist-form');
    Object.entries(formDataFromQuery).forEach(([key, value]) => {
      const input = form[key];
      if (input) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.checked = value === 'on' || input.value === value;
        } else {
          input.value = value;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
